import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PlanningStatus } from './enums';

interface StatusDetail {
  label: string;
  classes: string;
  key: string;
}

type StatusMapping = { [key in PlanningStatus]: Partial<StatusDetail> } & {
  default: Partial<StatusDetail>;
};

@Component({
  selector: 'daas-consulting-planning-statuses',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './planning-statuses.component.html',
  styleUrl: './planning-statuses.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanningStatusesComponent {
  @Input() status: string | null = null;

  // Mapeo de estados a clases y etiquetas
  readonly #statusMapping: Partial<StatusMapping> = {
    [PlanningStatus.control]: {
      label: 'Control',
      classes: 'status__control',
    },
    [PlanningStatus.approved]: {
      label: 'Aprobada',
      classes: 'status__approved',
    },
    [PlanningStatus.produced]: {
      label: 'Producción',
      classes: 'status__produced',
    },
    [PlanningStatus.rejected]: {
      label: 'Rechazada',
      classes: 'status__rejected',
    },
    [PlanningStatus.issued]: {
      label: 'Expedición',
      classes: 'status__issued',
    },
    [PlanningStatus.delivered]: {
      label: 'Entregada',
      classes: 'status__delivered',
    },
    [PlanningStatus.canceled]: {
      label: 'Cancelada',
      classes: 'status__rejected',
    },
    [PlanningStatus.pending]: {
      label: 'Pendiente',
      classes: 'status__pending',
    },
    [PlanningStatus.inbox]: {
      label: 'Bandeja de entrada',
      classes: 'status__inbox',
    },
    default: {
      label: 'S/N',
      classes: 'status__default',
    },
  };

  // Obtener la clase y la etiqueta según el estado
  get statusDetails(): StatusDetail {
    const rv = <StatusDetail>(
      (this.#statusMapping[this.status as keyof typeof PlanningStatus] ||
        this.#statusMapping.default)
    );
    if (rv.label === this.#statusMapping.default?.label) {
      rv.key = <string>this.status;
    }

    return rv;
  }
}
